import { render, staticRenderFns } from "./CutSpeed.vue?vue&type=template&id=5d44aa00&"
import script from "./CutSpeed.vue?vue&type=script&lang=js&"
export * from "./CutSpeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QMarkupTable,QInput,QBtn} from 'quasar'
component.options.components = Object.assign({QMarkupTable,QInput,QBtn}, component.options.components || {})
